import { OneWayInFeedbackCollectionDto, OneWayInFeedbackUpsertDto, OneWayInOpportunityDto } from 'src/api/v2';
import { Counties } from '../constants/counties';

const createAutomaticFeedbackUpsertDto = (
  clusterId: string | undefined,
  opportunity: OneWayInOpportunityDto | undefined,
  feedbackCollection: OneWayInFeedbackCollectionDto | undefined,
): OneWayInFeedbackUpsertDto => ({
  id: undefined,
  clusterId: clusterId ?? '',
  oneWayInOpportunityD365Id: opportunity?.oneWayInId ?? '',
  title: opportunity?.title || '',
  municipality: opportunity?.municipality || '',
  county:
    feedbackCollection?.actorFeedback?.county ||
    Counties.find((county) =>
      county.municipalities.some((municipality) => municipality === opportunity?.municipality),
    )?.countyName ||
    undefined,
  comment: 'Automatisk tilbakemelding',
  wasCorrectlyReferred: true,
  suggestedActors: undefined,
  isAutomatic: true,
});

export default createAutomaticFeedbackUpsertDto;
